// Shared OTP error helpers for MFA and Sunburst flows

const OTP_INVALID_DETAILS = [
  'Code is invalid.',
  'Code is invalid or expired.',
  'Code is invalid',
  'Code is invalid or expired',
];
const OTP_EXPIRED_DETAIL = 'Code is expired.';
const OTP_EXPIRED_DETAIL_NO_PERIOD = 'Code is expired';

export function isInlineOtpInvalidError(error) {
  if (typeof error?.otpCodeInvalid === 'function' && error.otpCodeInvalid()) return true;
  const detail = (typeof error?.getDetail === 'function' && error.getDetail(0)) || error?.errors?.[0]?.detail;
  // Normalize detail: trim, remove trailing period, case-insensitive
  const normalized = (detail || '').trim().replace(/[.。]$/, '').toLowerCase();
  return error?.status === 422 && OTP_INVALID_DETAILS.some(
    d => normalized === d.replace(/[.。]$/, '').toLowerCase()
  );
}

export function isOtpExpiredError(error) {
  if (typeof error?.otpCodeExpired === 'function' && error.otpCodeExpired()) return true;
  const detail = (typeof error?.getDetail === 'function' && error.getDetail(0)) || error?.errors?.[0]?.detail;
  // Normalize detail: trim, remove trailing period, case-insensitive
  const normalized = (detail || '').trim().replace(/[.。]$/, '').toLowerCase();
  return error?.status === 409 && (
    normalized === OTP_EXPIRED_DETAIL.replace(/[.。]$/, '').toLowerCase() ||
    normalized === OTP_EXPIRED_DETAIL_NO_PERIOD.toLowerCase()
  );
}

export { OTP_INVALID_DETAILS, OTP_EXPIRED_DETAIL };
